import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/common/preloader/preloader.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { TestimonialsComponent } from './components/pages/testimonials/testimonials.component';
import { PartnerComponent } from './components/pages/partner/partner.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { TimelineComponent } from './components/pages/timeline/timeline.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './components/pages/terms-conditions/terms-conditions.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { AboutMeComponent } from './components/pages/about-me/about-me.component';
import { WorksComponent } from './components/pages/works/works.component';
import { WorksDetailsComponent } from './components/pages/works-details/works-details.component';
import { VideosComponent } from './components/pages/videos/videos.component';
import { VideosDetailsComponent } from './components/pages/videos-details/videos-details.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { OmanFixerComponent } from './components/pages/oman-fixer/oman-fixer.component';
import { FilmingInOmanComponent } from './components/pages/filming-in-oman/filming-in-oman.component';
import { ProductionComponent } from './components/pages/production/production.component';
import { BehindTheScenesComponent } from './components/pages/behind-the-scenes/behind-the-scenes.component';
import { AboutOmanComponent } from './components/pages/about-oman/about-oman.component';
import { OmanComponent } from './components/pages/oman/oman.component';
import { RevealOnScrollDirective } from './directives/reveal-on-scroll.directive';
import { SafeUrlPipe } from './pipes/safe-url.pipe';

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    NavbarComponent,
    FooterComponent,
    HomeOneComponent,
    HomeTwoComponent,
    HomeThreeComponent,
    FeaturesComponent,
    TeamComponent,
    TestimonialsComponent,
    PartnerComponent,
    PricingComponent,
    TimelineComponent,
    FaqComponent,
    ErrorComponent,
    ComingSoonComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    AboutUsComponent,
    AboutMeComponent,
    WorksComponent,
    WorksDetailsComponent,
    VideosComponent,
    VideosDetailsComponent,
    BlogComponent,
    BlogDetailsComponent,
    ContactComponent,
    OmanFixerComponent,
    FilmingInOmanComponent,
    ProductionComponent,
    BehindTheScenesComponent,
    AboutOmanComponent,
    OmanComponent,
    RevealOnScrollDirective,
    SafeUrlPipe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
